export default __webpack_public_path__ + "c3c06ef8dc70f8b6de77f1b88237e74d.png";